import React from "react";
import { Box, Typography } from "@mui/material";

const FeatureCard = ({ imgSrc, title, description }) => {
    return (
        <Box
            sx={{
                textAlign: "center",
                maxWidth: "200px",
                margin: "auto",
                mt: { md: "-82px", xs: "0px" },
                transition: "transform 0.3s ease", // Animation for the entire card
                "&:hover": {
                    transform: "scale(1.05)", // Slightly enlarge the card on hover
                },
            }}
        >
            {/* Diamond Shape Container */}
            <Box
                sx={{
                    width: "100px",
                    height: "100px",
                    backgroundColor: "#FEFCFA",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto",
                    transform: "rotate(45deg)",
                    mb: 2,
                    border: "1px solid #E1DCDC",
                    transition: "transform 0.3s ease", // Animation for the diamond shape
                    "&:hover": {
                        transform: "rotate(45deg) scale(1.1)", // Rotate and scale on hover
                    },
                }}
            >
                <Box
                    component="img"
                    src={imgSrc}
                     loading="lazy"
                    alt={title}
                    sx={{
                        transform: "rotate(-45deg)",
                        width: "60px", // Adjust the size of the image
                        height: "60px",
                        objectFit: "contain",
                        transition: "transform 0.3s ease", // Animation for the image
                       
                    }}
                />
            </Box>

            {/* Title */}
            <Typography
                sx={{
                    color: "#C49A6C",
                    fontSize: {
                        xs: "18px", // Small screens
                        sm: "20px", // Medium screens
                        md: "22px", // Large screens
                        lg: "24px", // Extra large screens
                    },
                    fontWeight: 700,
                    mb: 2,
                    mt: 3,
                    transition: "color 0.3s ease", // Animation for the text color
                    "&:hover": {
                        color: "#E1DCDC", // Change text color on hover
                    },
                }}
            >
                {title}
            </Typography>

            {/* Description */}
            <Typography
                sx={{
                    color: "#B0B0B0",
                    fontSize: {
                        xs: "12px", // Small screens
                        sm: "14px", // Medium screens
                        md: "16px", // Large screens
                        lg: "16px", // Extra large screens
                    },
                    lineHeight: "33px",
                    fontWeight: 400,
                    mb: 3,
                    transition: "opacity 0.3s ease", // Animation for description opacity
                    "&:hover": {
                        opacity: 0.8, // Fade out slightly on hover
                    },
                }}
            >
                {description}
            </Typography>
        </Box>
    );
};

export default FeatureCard;
